import * as React from 'react'

import { TProductDetailState } from '~logic/xstate/machines/menu/productDetailMachineTypes'
import { menuScreenElementIds } from '~shared/config/menuScreenElementIds'
import { productDetailLayoutSettings } from '~shared/config/productDetailLayoutSettings'
import { CategoryNavigation } from '~shared/segments/ProductList'
import { Grid } from '~ui/components/layout/Box'
import { getHeaderFontSizeInPx } from '~ui/styleGuide/fontStyles'
import { getSpacingValueInPx } from '~ui/styleGuide/spaces'

import { useAddonListSelection } from '../hooks/useAddonListSelection'

const { addonStickyContentId, addonListContainerId } = menuScreenElementIds

const {
  defaultHeadingLineHeight,
  mobileProductHeadingFontSize,
  mobileProductHeadingPaddingTop,
  mobileProductHeadingPaddingBottom,
} = productDetailLayoutSettings

const nameLabelHeightPx =
  getHeaderFontSizeInPx(mobileProductHeadingFontSize) * defaultHeadingLineHeight +
  getSpacingValueInPx(mobileProductHeadingPaddingTop) +
  getSpacingValueInPx(mobileProductHeadingPaddingBottom)

type TAddonCategory = TProductDetailState['addonCategories'][number]

type TProps = NoChildren & {
  addonCategories: RoA<TAddonCategory>
  /**
   * height of the sticky content = addon category navigation
   */
  stuckContentHeight: FirstParam<typeof useAddonListSelection>['stuckContentHeight']
}

/**
 * Category navigation (RollingOptions) for optional addon categories.
 */
export const AddonCategoryNavigation: React.FC<TProps> = ({
  addonCategories,
  stuckContentHeight,
}) => {
  const { selectedId, onSelection } = useAddonListSelection({
    addonCategories,
    knownStickyContentHeightPx: nameLabelHeightPx,
    stuckContentHeight,
  })

  return (
    <Grid
      zIndex={2}
      bgColor={`bgColors.card`}
      overflow={`hidden`}
      position={`sticky`}
      shadow={`bottomLong`}
      id={addonStickyContentId}
      gridTemplateColumns={`100%`}
      top={`calc(${nameLabelHeightPx}px - 1px)`}
      padding={{ top: `smallMedium`, bottom: `extraSmall`, left: `medium`, right: `none` }}
    >
      <CategoryNavigation
        direction={`row`}
        selectedId={selectedId}
        bgColor={`inputOnCard`}
        onSelection={onSelection}
        categories={addonCategories}
        scrollOverflowId={addonListContainerId}
      />
    </Grid>
  )
}
